(function () {
  const iller = [
    "Adana",
    "Adıyaman",
    "Afyonkarahisar",
    "Ağrı",
    "Amasya",
    "Ankara",
    "Antalya",
    "Artvin",
    "Aydın",
    "Balıkesir",
    "Bilecik",
    "Bingöl",
    "Bitlis",
    "Bolu",
    "Burdur",
    "Bursa",
    "Çanakkale",
    "Çankırı",
    "Çorum",
    "Denizli",
    "Diyarbakır",
    "Edirne",
    "Elazığ",
    "Erzincan",
    "Erzurum",
    "Eskişehir",
    "Gaziantep",
    "Giresun",
    "Gümüşhane",
    "Hatay",
    "Isparta",
    "Mersin",
    "İstanbul",
    "İzmir",
    "Kars",
    "Kastamonu",
    "Kayseri",
    "Kırklareli",
    "Kırşehir",
    "Kocaeli",
    "Konya",
    "Kütahya",
    "Malatya",
    "Manisa",
    "Kahramanmaraş",
    "Mardin",
    "Muğla",
    "Muş",
    "Nevşehir",
    "Niğde",
    "Ordu",
    "Rize",
    "Sakarya",
    "Samsun",
    "Siirt",
    "Sinop",
    "Sivas",
    "Tekirdağ",
    "Tokat",
    "Trabzon",
    "Tunceli",
    "Şanlıurfa",
    "Uşak",
    "Van",
    "Yozgat",
    "Zonguldak",
    "Aksaray",
    "Bayburt",
    "Karaman",
    "Kırıkkale",
    "Batman",
    "Şırnak",
    "Bartın",
    "Ardahan",
    "Iğdır",
    "Yalova",
    "Karabük",
    "Kilis",
    "Osmaniye",
    "Düzce",
  ];

  // Maps the ?bakici-bul= URL param value to a service dropdown value
  const serviceMap = {
    "kopek-gezdirme": "Planned",
    "kedi-pansiyon": "CatBoarding",
    "kopek-pansiyon": "Boarding",
  };

  function populateCities() {
    const cityDropdown = document.getElementById("dm-city-select");
    if (cityDropdown && cityDropdown.options.length <= 1) {
      iller
        .sort((a, b) => a.localeCompare(b, "tr"))
        .forEach((il) => {
          let opt = document.createElement("option");
          opt.value = il;
          opt.innerHTML = il;
          cityDropdown.appendChild(opt);
        });
    }
  }

  function openModal(servicePreset) {
    populateCities();
    const modal = document.getElementById("doggo-modal");
    if (!modal) return;
    modal.style.display = "flex";

    if (servicePreset) {
      const serviceDropdown = document.getElementById("dm-service-select");
      if (serviceDropdown) serviceDropdown.value = servicePreset;
    }
  }

  // Open modal on page load when URL contains ?bakici-bul=<service>
  // e.g. /?bakici-bul=kopek-gezdirme
  document.addEventListener("DOMContentLoaded", function () {
    const params = new URLSearchParams(window.location.search);
    const serviceParam = params.get("bakici-bul");
    if (serviceParam !== null) {
      const servicePreset = serviceMap[serviceParam] || null;
      openModal(servicePreset);
      // Clean the URL so the param doesn't persist on refresh
      const cleanUrl = window.location.pathname;
      history.replaceState(null, "", cleanUrl);
    }
  });

  document.addEventListener("click", function (e) {
    // Supports data-open-doggo-modal attribute (preferred for in-page triggers)
    // and legacy href="#doggo-modal" (kept for backward compatibility)
    const trigger =
      e.target.closest("[data-open-doggo-modal]") ||
      e.target.closest('a[href="#doggo-modal"]');

    if (trigger) {
      e.preventDefault();
      const servicePreset =
        trigger.getAttribute("data-open-doggo-modal") || null;
      openModal(servicePreset);
    }

    if (
      e.target.classList.contains("dm-close") ||
      e.target.classList.contains("dm-overlay")
    ) {
      const modal = document.getElementById("doggo-modal");
      if (modal) modal.style.display = "none";
    }

    if (e.target.id === "dm-submit-button") {
      const city = document.getElementById("dm-city-select").value;
      const service = document.getElementById("dm-service-select").value;
      const dateVal = document.getElementById("dm-date-select").value;

      if (!city || !service || !dateVal) {
        alert("Lütfen tüm alanları doldurunuz.");
        return;
      }

      const dateObj = new Date(dateVal);
      const formattedDate = `${
        dateObj.getMonth() + 1
      }/${dateObj.getDate()}/${dateObj.getFullYear()}`;
      const baseUrl = "https://www.doggoapp.com/owner/auth/partner/list";
      let utmCampaign =
        service === "Planned" ? "shop_mpwalk" : "shop_mpsitting";

      const params = new URLSearchParams({
        service: service,
        city: city,
        checkInTime: formattedDate,
        utm_source: "shop",
        utm_medium: "shop_website",
        utm_campaign: utmCampaign,
        utm_content: "shop_header_redirection",
      });

      window.location.href = `${baseUrl}?${params.toString()}`;
    }
  });
})();
